// axios 0.x 기본 paramsSerializer와 동작을 맞추는 직렬화 함수.
//
// axios 1.x 기본 동작은 중첩 객체를 bracket notation으로 flatten하지만
// (예: { tracking: { a: 1, b: 2 } } → tracking[a]=1&tracking[b]=2),
// 백엔드는 v0 시절의 "객체 값을 JSON.stringify한 단일 문자열"을 전제로 설계돼 있음
// (예: tracking={"a":1,"b":2}). 이를 유지해 동작 호환을 보장한다.
//
// v0 규칙 (axios/lib/helpers/buildURL 0.27.2):
// - null/undefined 값은 스킵
// - Array 값은 key에 `[]` suffix 붙이고 각 요소 반복
// - Date 값은 toISOString()
// - Object 값은 JSON.stringify()
// - 그 외는 그대로 encodeURIComponent

export function legacyParamsSerializer(params) {
  if (!params) return "";
  const parts = [];
  Object.keys(params).forEach(key => {
    const val = params[key];
    if (val === null || typeof val === "undefined") return;
    const isArr = Array.isArray(val);
    const effectiveKey = isArr ? key + "[]" : key;
    const values = isArr ? val : [val];
    values.forEach(raw => {
      let v = raw;
      if (v instanceof Date) {
        v = v.toISOString();
      } else if (v !== null && typeof v === "object") {
        v = JSON.stringify(v);
      }
      parts.push(encodeURIComponent(effectiveKey) + "=" + encodeURIComponent(v));
    });
  });
  return parts.join("&");
}
